"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockUserCompanyRoles = exports.getMockCompany = void 0;
const enums_1 = require("../../../contracts/enums");
const getMockCompany = ({ _id = "companies-default", status = enums_1.CompanyStatus.SetUpInProgress, name = "BOULEVARD Pty Ltd", displayName = "Liquidise", companyType = "Private Company", acn = "123456789", abn = "00123456789", displayLogo = "", primaryAdminId = "users-primary-default", kycIsKycDone = true, kycDateOfNomination = new Date(), kycHasNominated = true, kycNomineeId = "users-nominee-1", kycNomineeToken = "", stripeSelectedPriceId = "price_1", stripeCustomerId = "cus_1", stripeSubscriptionId = "sub_1", stripeSubscriptionPlanId = "plan3", stripeSubscriptionStatus = "active", stripeSelectedTier = "tier4", tncAccepted = true, registeredAddressId = "addresses-testId", principalPlaceOfBusinessAddressId = "addresses-testId", agentNumber = "12345", isAdminAuthorized = true, isAgentAuthorized = true, isAsicConnectionActivated = true, lastAccess = new Date(), dateOfRegistration = new Date(2020, 12, 15), code = "ABC", shareCertificateConfig = {
    enableShareCertificates: true,
    prefix: "MY2",
    startNumber: 1,
    officeholders: [{ _id: "officeholderid-1", fontFamily: "caveat" }],
}, notesCertificateConfig = {
    enableNotesCertificates: true,
    officeholders: [{ _id: "officeholderid-1", fontFamily: "caveat" }],
}, liquidiseConfig = {
    auctionId: "auction-1",
    fundWalletId: "wallet-1",
    fundShareholderId: "shareholder-1",
    companyAddress: "address-1",
}, fundraiseConfig = {
    fundraiseTncAccepted: true,
    paytron: {},
}, companyContactEmail = "", } = {}) => ({
    _id,
    status,
    name,
    displayName,
    companyType,
    acn,
    abn,
    displayLogo,
    primaryAdminId,
    kycAuthorization: {
        hasNominated: kycHasNominated,
        isKYCDone: kycIsKycDone,
        nomineeId: kycNomineeId,
        dateOfNomination: kycDateOfNomination,
        nomineeToken: kycNomineeToken,
    },
    stripeData: {
        customerId: stripeCustomerId,
        selectedPriceId: stripeSelectedPriceId,
        subscriptionId: stripeSubscriptionId,
        selectedSubscriptionPlan: stripeSubscriptionPlanId,
        subscriptionStatus: stripeSubscriptionStatus,
        selectedTier: stripeSelectedTier,
    },
    tncAccepted,
    registeredAddressId,
    principalPlaceOfBusinessAddressId,
    agentNumber,
    isAdminAuthorized,
    isAgentAuthorized,
    isAsicConnectionActivated,
    lastAccess,
    dateOfRegistration,
    code,
    shareCertificateConfig,
    fundraiseConfig,
    liquidiseConfig,
    notesCertificateConfig,
    companyContactEmail,
});
exports.getMockCompany = getMockCompany;
const getMockUserCompanyRoles = ({ isSuperAdmin = false, isAdmin = false, isInvestor = false, isExternalInvestor = false, isConcierge = false, isNominee = false, isDirector = false, isCompanySecretary = false, } = {}) => ({
    isSuperAdmin,
    isAdmin,
    isInvestor,
    isExternalInvestor,
    isConcierge,
    isNominee,
    isDirector,
    isCompanySecretary,
});
exports.getMockUserCompanyRoles = getMockUserCompanyRoles;
//# sourceMappingURL=company.mock.js.map